<template>
  <div class="zujianBox">
    <div class="boxA" >
        <div class="boxAcont">
            <div class="itemA">
              <p class="name color1">{{totalData.historyUpTotal}}</p>
              <p class="name1">历史装船量总计(吨)</p>
            </div>
            <div class="itemA">
              <p class="name color1">{{totalData.historyDownTotal}}</p>
              <p class="name1">历史卸船量总计(吨)</p>
            </div>
        </div>
      </div>
      <div class="zjBottom">
        <el-row :gutter="12">
          <el-col :span="12">
            <div class="boxA">
            <div class="left_h">
              <span class="span_one">当日装卸船量对比(吨)</span>
            </div>
            <div class="boxAcont" id="zhu1">

            </div>
          </div>
          </el-col>
          <el-col :span="12">
            <div class="boxA">
            <div class="left_h">
              <span class="span_one">历史装卸船量对比(吨)</span>
            </div>
            <div class="boxAcont" id="zhu2">

            </div>
          </div>
          </el-col>
        </el-row>

      </div>
  </div>
</template>
<script>
import { shipTotal } from '@/api/data-center-server'
export default {
  data () {
    return {
      totalData: {}
    }
  },
  created () {

  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      shipTotal({}).then(res => {
        this.totalData = res
        // 柱状图数据
        var valueUpData1 = []
        var valueUpData2 = []
        var valueDownData1 = []
        var valueDownData2 = []
        var nameData = []
        res.list.forEach((item, index) => {
          nameData.push(item.tenantName)
          valueUpData1.push(item.currUpTotal)
          valueDownData1.push(item.currDownTotal)
          valueUpData2.push(item.historyUpTotal)
          valueDownData2.push(item.historyDownTotal)
        })
        this.zhuChart(nameData, valueUpData1, valueDownData1, 'zhu1')
        this.zhuChart(nameData, valueUpData2, valueDownData2, 'zhu2')
      })
    },
    zhuChart (nameData, valueUpData, valueDownData, id) {
      let myChart = this.$echarts.init(document.getElementById(id))
      // 绘制图表--柱状
      myChart.setOption({
        color: ['#0DD9FE', '#52F23A'],
        // backgroundColor: "#323a5e",
        grid: {
          left: '2%',
          right: '4%',
          bottom: '9%',
          top: '25%',
          containLabel: true
        },
        legend: {
          icon: 'circle',
          data: ['装船量', '卸船量'],
          textStyle: {
            color: '#fff'
          }
        },
        // ---  提示框 ----
        tooltip: {
          show: true, // 是否显示提示框，默认为true
          trigger: 'item', // 数据项图形触发
          axisPointer: {
            // 指示样式
            type: 'shadow',
            axis: 'auto'
          },
          formatter: function (value) {
            return value.marker + value.seriesName + '：' + value.value
          },
          padding: 5,
          textStyle: {
            // 提示框内容的样式
            color: '#fff'
          }
        },
        calculable: true,
        xAxis: {
          type: 'category',
          data: nameData,
          axisLine: {
            lineStyle: {
              color: 'white'
            }
          },
          axisLabel: {
            interval: 0,
            rotate: 50,
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            },
            formatter: function (data) {
              let valueTxt = ''
              if (data.length > 5) {
                valueTxt = data.substring(0, 6) + '...' // 想要展示的x轴名称长度
              } else {
                valueTxt = data
              }
              return valueTxt
            }
          }
        },
        yAxis: {
          type: 'value',
          data: ['2000', '4000', '6000', '8000'],
          axisLine: {
            show: false,
            lineStyle: {
              color: 'white'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {}
        },
        series: [
          {
            name: '装船量',
            type: 'bar',
            barGap: 0,
            barWidth: '15%',
            data: valueUpData
          },
          {
            name: '卸船量',
            type: 'bar',
            barGap: 0,
            barWidth: '15%',
            data: valueDownData
          }
        ]
      })
    }
  },
  computed: {

  },
  filters: {

  },
  destroyed () {
    clearInterval(this.nowTimer)
    clearInterval(this.mapTimer)
  }
}
</script>

<style lang="less" scoped>
.zujianBox{
  height: 100%;
  width: 100%;
  display: flex;
 flex-direction: column;
  .boxAcont{
    padding: 12px 0;
  }
}
.zjBottom{
  flex: 1;
  margin-top: 12px;
  .boxA{
    height: 100%;
  }
}
/deep/.el-row{
  height: 100%;
  display: flex;
  .el-col{
  height: 100%;
  }
}
.boxA{
    width: 100%;
    border: 1px solid #045f59;
    box-shadow: -8px 16px 62px -18px rgba(18,102,210,0.75) inset;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .boxAcont{
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex: 1;
      text-align: center;
      .name{
        font-size: 24px;
        margin-bottom: 10px;
      }
      .name1{
        color: #ffffff;
        font-size: 12px;
      }
      p{
        margin: 0;
      }
    }
}
.left_h {
  height: 40px;
  line-height: 40px;
  color: #03faec;
  // font-weight: 700;
  font-size: 20px;
  background: rgba(41, 139, 208, 0.3);
  box-shadow: -8px 16px 62px -18px rgba(18,102,210,0.75);
  .span_one {
    float: left;
    margin-left: 10px;
    font-size: 16px;
  }
  .span_two {
    float: right;
    margin: 5px;
    font-size: 16px;

    font-weight: normal;
  }
}
.color1{
    color: #03faec;
}
.color2{
    color: #ffa500;
}
.color3{
    color: #4df442;
}
.color4{
    color: #2e9cfd;
}
.color5{
    color: #fffc0d;
}
</style>
